import { c as _c } from "react/compiler-runtime";
import ContactHero from "@/components/contact/ContactHero";
import ContactInfo from "@/components/contact/ContactInfo";
import ContactForm from "@/components/contact/ContactForm";
import FAQ from "@/components/shared/FAQ";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
export default function Contact() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("contact");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
      name: "Home",
      path: "/"
    }, {
      name: "Contact",
      path: "/contact"
    }])} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<main className="min-h-screen bg-[#F4EFE6]"><ContactHero /><ContactInfo /><ContactForm /><FAQ /></main></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}